import loadDetailsTypes from './loadDetailsTypes'

export const openLoadDetails = payload => ({
  type: loadDetailsTypes.OPEN_LOAD_DETAILS,
  payload
})

export const clearLoadDetails = () => ({
  type: loadDetailsTypes.CLEAR_LOAD_DETAILS
})

export const bidOrder = payload => ({
  type: loadDetailsTypes.BID_ORDER,
  payload
})

export const bidOrderSuccess = payload => ({
  type: loadDetailsTypes.BID_ORDER_SUCCESS,
  payload
})

export const bidOrderFailure = payload => ({
  type: loadDetailsTypes.BID_ORDER_FAILURE,
  payload
})

export const bookOrder = payload => ({
  type: loadDetailsTypes.BOOK_ORDER,
  payload
})

export const bookOrderSuccess = payload => ({
  type: loadDetailsTypes.BOOK_ORDER_SUCCESS,
  payload
})

export const bookOrderFailure = payload => ({
  type: loadDetailsTypes.BOOK_ORDER_FAILURE,
  payload
})

export const bidOffer = payload => ({
  type: loadDetailsTypes.BID_OFFER,
  payload
})

export const bidOfferSuccess = payload => ({
  type: loadDetailsTypes.BID_OFFER_SUCCESS,
  payload
})

export const bidOfferFailure = payload => ({
  type: loadDetailsTypes.BID_OFFER_FAILURE,
  payload
})

export const bookOffer = payload => ({
  type: loadDetailsTypes.BOOK_OFFER,
  payload
})

export const bookOfferSuccess = payload => ({
  type: loadDetailsTypes.BOOK_OFFER_SUCCESS,
  payload
})

export const bookOfferFailure = payload => ({
  type: loadDetailsTypes.BOOK_OFFER_FAILURE,
  payload
})

export const getMapImage = payload => ({
  type: loadDetailsTypes.GET_MAP_IMAGE,
  payload
})

export const getMapImageSuccess = payload => ({
  type: loadDetailsTypes.GET_MAP_IMAGE_SUCCESS,
  payload
})

export const getMapImageFailure = payload => ({
  type: loadDetailsTypes.GET_MAP_IMAGE_FAILURE,
  payload
})

export const getTractorDetails = payload => ({
  type: loadDetailsTypes.GET_TRACTOR_DETAILS,
  payload
})

export const getTractorDetailsSuccess = payload => ({
  type: loadDetailsTypes.GET_TRACTOR_DETAILS_SUCCESS,
  payload
})

export const getTractorDetailsFailure = payload => ({
  type: loadDetailsTypes.GET_TRACTOR_DETAILS_FAILURE,
  payload
})
